<template lang="pug">
v-card
  v-card-title: h1 Menu Items
  v-card-text
    menu-tree(:parent="parent" :menus="menus" @move="move($event)" :edit="edit" @edit="startEdit($event)" :dragging="dragging" @dragging="dragging = $event")
    v-btn(@click="startCreate()")
      v-icon add
      | Menu Item
    v-dialog(:value="!!edit" lazy @input="cancelEdit()" max-width="600")
      v-card(v-if="edit")
        v-card-text
          v-text-field(label="Name" v-model="edit.name" :error-messages="gqlErrorsFor('menuItemMod', 'name')")
          template(v-if="['placeholder', 'url'].indexOf(edit.kind) === -1")
            v-text-field(label="Slug" v-model="edit.slug" placeholder="wird aus Name generiert" :error-messages="gqlErrorsFor('menuItemMod', 'slug')")
            v-select(label="Layout" v-model="edit.layoutId" :items="layouts" item-value="id" item-text="name" :error-messages="gqlErrorsFor('menuItemMod', 'layout_id')")
          v-select(label="State" v-model="edit.state" :items="states")
          v-select(label="Art" v-model="edit.kind" :items="kinds" :error-messages="gqlErrorsFor('menuItemMod', 'kind')")
          template(v-if="edit.kind === 'page'")
            v-autocomplete(label="Content" v-model="edit.contentId" :items="beitraege" item-value="id" item-text="title" :error-messages="gqlErrorsFor('menuItemMod', 'content_id')")
          template(v-else-if="edit.kind === 'category'")
            v-autocomplete(label="Category" v-model="edit.categoryId" :items="kategorien" item-value="id" item-text="nameMitTiefe" :error-messages="gqlErrorsFor('menuItemMod', 'category_id')")
            v-autocomplete(label="Template" v-model="edit.template" :items="templates" :error-messages="gqlErrorsFor('menuItemMod', 'template')")
          template(v-else-if="edit.kind === 'url'")
            v-text-field(label="URL" v-model="edit.link" :error-messages="gqlErrorsFor('menuItemMod', 'link')")

        v-card-actions
          v-btn(outline color="primary" @click="saveEdit()") Speichern
          v-btn(flat @click="cancelEdit()") Abbrechen
          v-spacer
          v-btn(flat v-if="edit && edit.id" @click="deleteEdit()") Löschen

</template>

<style lang="stylus" scoped>

</style>


<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../../mixins/graphql-error-object.js'
import MenuTree from './menu-tree'

function buildChildMenuTree(item, menus) {
  const menu = item.menu
  let ancestry = menu.ancestry ? `${menu.ancestry}/${menu.id}` : `${menu.id}`
  item.children = menus.filter(m => {
    if (m.ancestry === ancestry) {
      return true
    }
  }).map(menu => {
    const m = { menu }
    buildChildMenuTree(m, menus)
    return m
  })
}

function buildMenuTree(menus) {
  if (menus) {
    return menus.filter(m => !m.ancestry).map(menu => { 
      const m = { menu }
      buildChildMenuTree(m, menus)
      return m
    })
  }
  return
}

export default {
  mixins: [GraphqlErrorObject],
  components: {
    MenuTree
  },
  data() {
    return {
      menuItems: [],
      layouts: [],
      beitraege: [],
      edit: null,
      dragging: null,
      states: [{ text: 'Sichtbar', value: 'visible' }, { text: 'Unsichtbar', value: 'invisible' }, { text: 'Deaktiviert', value: 'offline' }],
      kinds: ['placeholder', 'leere_seite', 'ganz_leere_seite', 'html', 'category', 'page', 'url'],
      templates: ['list', 'list-big']
    }
  },
  apollo: {
    menuItems: gql`{
      menuItems(order: "position") {
        id
        name
        slug
        kind
        state
        position
        ancestry
        layoutId
        contentId
        categoryId
        link
        template
        html
      }
    }`,
    layouts: gql`{
      layouts { id name }
    }`,
    beitraege: gql`{
      beitraege { id title }
    }`,
    kategorien: gql`{
      kategorien(order: "position") { id nameMitTiefe }
    }`
  },
  computed: {
    parent() {
      return {
        menu: { id: null, },
        children: this.menus
      }
    },
    menus() {
      return buildMenuTree(this.menuItems)
    }
  },
  methods: {
    move(move) {
      const change = { id: move.data.menu.id }
      if (move.type === 'in') {
        change.childOf = move.menu.menu.id
      } else if (move.type === 'after') {
        change.rightOf = move.menu.menu.id
      } else if (move.type === 'first') {
        change.leftOf = move.parent.children[0].menu.id
      }
      if (change.id && (change.childOf || change.leftOf || change.rightOf)) {
        this.gqlClearAllErrors()
        return this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!, $childOf: ID, $leftOf: ID, $rightOf: ID) {
            menuItemMod: menuItemUpdate(id: $id, childOf: $childOf, leftOf: $leftOf, rightOf: $rightOf) {
              id
              position
              ancestry
            }
          }`,
          variables: change,
        }).then((data) => {
          this.$apollo.queries.menuItems.refetch()
          this.cancelEdit()
        }).catch((error) => {
          this.gqlAddErrors(error)
        })
      }
    },
    startEdit(item) {
      this.edit = Object.assign({}, item.menu)
    },
    startCreate(item) {
      this.edit = {
        id: null,
        name: '',
        slug: null,
        kind: 'placeholder',
        state: 'visible',
        ancestry: null,
        layoutId: (this.layouts.find(l => l.name === "Default") || {}).id || null,
        contentId: null,
        categoryId: null,
        link: null,
        template: null,
        html: null,
      }
    },
    cancelEdit() {
      this.edit = null
    },
    saveEdit() {
      const edit = this.edit
      this.gqlClearAllErrors()
      return this.$apollo.mutate({
        mutation: gql`mutation (${edit.id ? '$id: ID!,' : ''} $name: String, $slug: String, $kind: String, $state: String, $ancestry: String, $layoutId: ID, $contentId: ID, $categoryId: ID, $link: String, $template: String, $html: String) {
          menuItemMod: menuItem${edit.id ? 'Update(id: $id,' : 'Create('} name: $name, slug: $slug, kind: $kind, state: $state, ancestry: $ancestry, layoutId: $layoutId, contentId: $contentId, categoryId: $categoryId, link: $link, template: $template, html: $html) {
            id
            name
            slug
            kind
            state
            ancestry
            layoutId
            contentId
            categoryId
            link
            template
            html
          }
        }`,
        variables: edit,
      }).then((data) => {
        if (!edit.id) {
          this.$apollo.queries.menuItems.refetch()
        }
        this.cancelEdit()
      }).catch((error) => {
        this.gqlAddErrors(error)
      })
    },
    deleteEdit() {
      if (!confirm(`${this.edit.name} löschen?`)) {
        return
      }
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!) {
          menuItemDestroy(id: $id) {
            success
          }
        }`,
        variables: {
          id: this.edit.id
        },
      }).then((data) => {
        this.$apollo.queries.menuItems.refetch()
        this.cancelEdit()
      }).catch((error) => {
        this.gqlAddErrors(error)
      })
    }
  }
}
</script>
